/** @jsxImportSource theme-ui */
import { gql } from "@apollo/client";
import { SemiTitle } from "@bottlebooks/gatsby-design-system";
import { Col, Container, Row } from "@bottlebooks/gatsby-theme-base/src";
import { Trans } from "@lingui/macro";
import { graphql } from "~/gql";
import Section from "../Section/Section";
import MarketingActivity, {
  MarketingActivityFragment,
} from "./MarketingActivity";

export default function MarketingActivitiesSection({ brand, ...rest }) {
  if (!brand) return null;
  // Manually check for virtual event content.
  if (!brand.marketing?.length) return null;
  return (
    <Section
      sx={{ backgroundColor: "primary", color: "onPrimary", paddingY: 4 }}
      {...rest}
    >
      <Container>
        <Row
          sx={{
            paddingX: [null, `${100 / 12}%`], // 1 col spacing from medium width up.
          }}
        >
          <Col sx={{ width: ["100%", "70%"] }}>
            <SemiTitle sx={{ borderBottom: 1, paddingY: 3, marginY: 0 }}>
              <Trans>Marketing activities</Trans>
            </SemiTitle>
            {brand.marketing?.length
              ? brand.marketing?.map((marketingActivity) => (
                  <MarketingActivity
                    key={marketingActivity.type}
                    variant="onPrimary"
                    activity={marketingActivity}
                    sx={{ borderBottom: 1, borderColor: "currentColor" }}
                  />
                ))
              : null}
          </Col>
        </Row>
      </Container>
    </Section>
  );
}

export const fragment = graphql(`
  fragment MarketingActivitiesSection on AbstractBrand {
    marketing {
      ...MarketingActivity
    }
  }
`);

export const MarketingActivitiesSectionFragment = gql`
  ${MarketingActivityFragment}
  fragment MarketingActivitiesSection on AbstractBrand {
    marketing {
      ...MarketingActivity
    }
  }
`;
